import React from "react"

interface EyeFitUIData {
    [key: string]: any
}

export const useEyeFitUIEvent = (dataForEyeFitUI: EyeFitUIData | null) => {
    React.useEffect(() => {
        // Assert the type locally to manipulate dataLayer with your specific properties
        const localDataLayer = (window.dataLayer || []) as Array<
            { event?: string } & EyeFitUIData
        >

        // Find the index of the 'eyefitu_init' event to possibly remove it
        const index = localDataLayer.findIndex(item => item.event === "eyefitu_init")
        if (index !== -1) {
            // Remove the existing event if found
            localDataLayer.splice(index, 1)
        }

        if (dataForEyeFitUI) {
            // Add the new event if data is provided
            localDataLayer.push({
                event: "eyefitu_init",
                ...dataForEyeFitUI
            })
        }

        // Assign back to window.dataLayer if needed
        window.dataLayer = localDataLayer
    }, [dataForEyeFitUI])
}
